// Example uses styled-components, but styled-system works with most other css-in-js libraries as well
import styled from 'styled-components';
import { layout, space, color, background } from 'styled-system';

import { getImagePath } from 'Util/pathUtils';

const ratio = (props) =>
  props.ratio
    ? {
        width: '100%',
        height: 0,
        paddingBottom: 100 / props.ratio + '%',
      }
    : null;

// Add styled-system functions to your component
const BackgroundImage = styled.div`
  ${space}
  ${layout}
  ${color}
  ${background}
  ${ratio}
  background-image: url(${({ src }) => getImagePath(src)});
`;

BackgroundImage.defaultProps = {
  width: 1,
  ratio: 4 / 3,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

export default BackgroundImage;
